import { PhoneNumbersV1 } from '@frontend/api-phone-numbers';
import { useAppFlagStore } from '@frontend/shared';
import { formatProtobufPhone } from '../utils';
import { useInboxLocationIds } from './use-inbox-location-ids';

type UseDefaultLocationPhonesArgs = {
  locationIds?: string[];
};

export const useDefaultLocationPhones = ({ locationIds: providedLocationIds }: UseDefaultLocationPhonesArgs = {}) => {
  const locationIds = useInboxLocationIds({ locationIds: providedLocationIds });
  const { getFeatureFlagValue } = useAppFlagStore();
  const canUseAllLocationPhones = getFeatureFlagValue({
    locationIds,
    flagName: 'phone-number-name-id',
    strategy: 'ALL',
  });
  return PhoneNumbersV1.Queries.useListPhoneNumbersForLocationsQuery({
    request: {
      locationIds,
      sms: true,
      excludeTenDlc: true,
    },
    options: {
      enabled: canUseAllLocationPhones && locationIds.length > 0,
      select: (data): Record<string, string> => {
        return (
          data.phoneNumbers?.reduce<Record<string, string>>((acc, { locationId, defaultSms, phoneNumber }) => {
            const formattedNumber = formatProtobufPhone(phoneNumber);
            if (defaultSms && formattedNumber) {
              acc[locationId] = formattedNumber;
            }

            return acc;
          }, {}) ?? {}
        );
      },
    },
  });
};
